__turbopack_context__.v({
  "gamesCount": "advanced-sidebar-prematch-module-sass-module__Ml_N0q__gamesCount" + " " + __turbopack_context__.i(402915)["gamesCount"],
  "selected": "advanced-sidebar-prematch-module-sass-module__Ml_N0q__selected",
  "sportsNav": "advanced-sidebar-prematch-module-sass-module__Ml_N0q__sportsNav" + " " + __turbopack_context__.i(286078)["sportsNav"],
  "sportsNavItem": "advanced-sidebar-prematch-module-sass-module__Ml_N0q__sportsNavItem" + " " + __turbopack_context__.i(402915)["sportsNavItem"],
});
